export default __webpack_public_path__ + "static/media/Fatima 9781408349595.46e4c79e.jpg";